var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArrowDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.93222 12.1174C5.14523 12.3245 5.4906 12.3245 5.70361 12.1174L10.0672 7.87496C10.1695 7.77551 10.227 7.64062 10.227 7.49998C10.227 7.35933 10.1695 7.22445 10.0672 7.125L5.70361 2.88257C5.4906 2.67548 5.14523 2.67548 4.93222 2.88257C4.71921 3.08967 4.71921 3.42544 4.93222 3.63253L8.91016 7.49998L4.93222 11.3674C4.71921 11.5745 4.71921 11.9103 4.93222 12.1174Z",
    fill: "#282828"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowDark);
export default __webpack_public_path__ + "static/media/right-arrow-dark.1ad42aa5ae94e2e631ac9009081380f2.svg";
export { ForwardRef as ReactComponent };